"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertContentIdToType = exports.convertContentIdToLifecycleId = void 0;
var regexContentId = /rrn:(content|master):([a-z0-9\-_]+:.+)/;
var regexContentType = /(rrn:(content|master):[a-z0-9\-_]+):.+/;
function convertContentIdToLifecycleId(contentResourceId) {
    var _a;
    var idPart = (_a = regexContentId.exec(contentResourceId)) === null || _a === void 0 ? void 0 : _a[2];
    if (!idPart) {
        throw new Error('Content resource could not be parsed correctly');
    }
    return "rrn:lifecycles:".concat(idPart);
}
exports.convertContentIdToLifecycleId = convertContentIdToLifecycleId;
function convertContentIdToType(contentResourceId) {
    var _a;
    var contentType = (_a = regexContentType.exec(contentResourceId)) === null || _a === void 0 ? void 0 : _a[1];
    if (!contentType) {
        throw new Error('Content resource could not be parsed correctly');
    }
    return contentType;
}
exports.convertContentIdToType = convertContentIdToType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFyc2UudXRpbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9wYXJzZS51dGlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQU0sY0FBYyxHQUFHLHdDQUF3QyxDQUFBO0FBQy9ELElBQU0sZ0JBQWdCLEdBQUcsd0NBQXdDLENBQUE7QUFFakUsU0FBZ0IsNkJBQTZCLENBQUMsaUJBQXlCOztJQUNyRSxJQUFNLE1BQU0sR0FBRyxNQUFBLGNBQWMsQ0FBQyxJQUFJLENBQUMsaUJBQWlCLENBQUMsMENBQUcsQ0FBQyxDQUFDLENBQUE7SUFFMUQsSUFBSSxDQUFDLE1BQU0sRUFBRTtRQUNYLE1BQU0sSUFBSSxLQUFLLENBQUMsZ0RBQWdELENBQUMsQ0FBQTtLQUNsRTtJQUVELE9BQU8seUJBQWtCLE1BQU0sQ0FBRSxDQUFBO0FBQ25DLENBQUM7QUFSRCxzRUFRQztBQUVELFNBQWdCLHNCQUFzQixDQUFDLGlCQUF5Qjs7SUFDOUQsSUFBTSxXQUFXLEdBQUcsTUFBQSxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsaUJBQWlCLENBQUMsMENBQUcsQ0FBQyxDQUFDLENBQUE7SUFFakUsSUFBSSxDQUFDLFdBQVcsRUFBRTtRQUNoQixNQUFNLElBQUksS0FBSyxDQUFDLGdEQUFnRCxDQUFDLENBQUE7S0FDbEU7SUFFRCxPQUFPLFdBQVcsQ0FBQTtBQUNwQixDQUFDO0FBUkQsd0RBUUMifQ==